import Vue from 'vue'
import Vuetify from 'vuetify'

import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify, { iconfont: 'mdi' })

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#5b2869',
        secondary: '#6A6A6A',
        accent: '#aad228',
        error: '#f44336',
        info: '#2196f3',
        success: '#4caf50'
      }
    }
  }
})
